import { UUID } from "@bitory-gmbh/nidavellir";

export const htzMicrobialBaseDataKey = "htz.inspection.microbialBaseData";

export interface MicrobialBaseData {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  /** The recommendation of a microbial assessment with a Warning result. */
  warningRecommendation: string;
  /** The recommendation of a microbial assessment with a Critical result. */
  criticalRecommendation: string;
}
